export default defineNuxtPlugin(nuxtApp => {
});